import React from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import { createNotificationFolder } from "../../../_redux/notification/notificationAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import NotificationCreateForm from "./NotificationCreateForm";

export default function NotificationCreate({
  show,
  onHide,
  onSubmit,
  defaultValues
}) {
  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>
            {defaultValues.uuid ? `Update Notifikasi` : "Tambah Notifikasi"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <NotificationCreateForm
            onSubmit={onSubmit}
            defaultValues={defaultValues}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
